import { Navigate, Route, Routes } from "react-router";

import { AdminAppShell } from "@/app/app-shell";
import { AccountPage } from "@/features/account/ui/account-page";
import { ApplicationsPage } from "@/features/applications/ui/applications-page";
import { AuditLogPage } from "@/features/audit/audit-log-page";
import { defaultAuthenticatedPath } from "@/features/auth/lib/auth-store";
import { useIsAuthenticated } from "@/features/auth/lib/use-auth";
import { AdminRoute, RequestsRoute } from "@/features/auth/ui/admin-route";
import { LoginPage } from "@/features/auth/ui/login-page";
import { ProtectedRoute } from "@/features/auth/ui/protected-route";
import { DiscountsPage } from "@/features/discounts/ui/discounts-page";
import { HotelPromosPage } from "@/features/hotel-promos/hotel-promos-page";
import { PartnersPage } from "@/features/partners/partners-page";
import { ReferralRedemptionsPage } from "@/features/referral/ui/referral-redemptions-page";
import { ReferralSettingsPage } from "@/features/referral/ui/referral-settings-page";
import { ReferralStatsPage } from "@/features/referral/ui/referral-stats-page";
import { UserDetailPage } from "@/features/users/ui/user-detail-page";
import { UsersPage } from "@/features/users/ui/users-page";
import { VerificationPage } from "@/features/verification/verification-page";

function HomeRedirect() {
	return <Navigate to={defaultAuthenticatedPath()} replace />;
}

function CatchAllRedirect() {
	const isAuthenticated = useIsAuthenticated();
	return (
		<Navigate
			to={isAuthenticated ? defaultAuthenticatedPath() : "/login"}
			replace
		/>
	);
}

export function AppRouter() {
	return (
		<Routes>
			<Route path="/login" element={<LoginPage />} />
			<Route element={<ProtectedRoute />}>
				<Route element={<AdminAppShell />}>
					<Route index element={<HomeRedirect />} />
					<Route element={<RequestsRoute />}>
						<Route path="/applications" element={<ApplicationsPage />} />
						<Route path="/applications/:id" element={<VerificationPage />} />
					</Route>
					<Route path="/account" element={<AccountPage />} />
					<Route element={<AdminRoute />}>
						<Route path="/users" element={<UsersPage />} />
						<Route path="/users/:id" element={<UserDetailPage />} />
						<Route path="/partners" element={<PartnersPage />} />
						<Route path="/discounts" element={<DiscountsPage />} />
						<Route
							path="/referral/settings"
							element={<ReferralSettingsPage />}
						/>
						<Route path="/hotel-promos" element={<HotelPromosPage />} />
						<Route path="/referral/stats" element={<ReferralStatsPage />} />
						<Route
							path="/referral/redemptions"
							element={<ReferralRedemptionsPage />}
						/>
						<Route path="/audit-log" element={<AuditLogPage />} />
					</Route>
				</Route>
			</Route>
			<Route path="*" element={<CatchAllRedirect />} />
		</Routes>
	);
}
